
import { defineComponent, SetupContext, ref } from "vue";
import NativeClient from "@/client/native-client";
import { StockQuantityInfo, RegisterPantryPlatePlateInfo, PlateInfoData } from "@/types/pantry";
import PantryDetailDataValue from "./PantryDetailDataValue.vue";

export default defineComponent({
  name: "PantryDetailTitleView",
  components: {
    PantryDetailDataValue
  },
  props: {
    itemType: {
      type: Number,
      default: -1
    },
    iconUrl: {
      type: String,
      defalut: ""
    },
    itemName: {
      type: String,
      defalut: ""
    },
    value: {
      type: String,
      defalut: ""
    },
    expirationDate: {
      type: String,
      defalut: ""
    },
    stockQuantity: {
      type: StockQuantityInfo,
      default: null
    },
    notificationStock: {
      type: RegisterPantryPlatePlateInfo,
      defalut: null
    },
    isShowArrow: {
      type: Boolean,
      defalut: true
    },
    plateData: {
      type: PlateInfoData,
      default: null
    }
  },
  setup(props, context: SetupContext) {
    const onClickItem = () => {
      context.emit("change-value", props.itemType);
    };
    return {
      onClickItem
    };
  }
});
